import {
  SET_NETWORKID, SET_PROVIDER, SET_ADDRESS, SET_ISCONNECTING,
  SET_HASERROR, FETCH_BALANCE, DELEGATE_START, DELEGATE_FAILURE, DELEGATE_END, DELEGATE_SUCCESS,
  FETCH_DELEGATES
  // SET_BALANCE, SET_ISFETCHINGBALANCE,
} from "../types/Metamask";
import { smartContractFetchRPC } from './Api';
import config from '../../Config';
import web3 from '../../utils/Web3';
import { TDropStakingAbi, TDropStakingAddress } from '../../constants/Contracts';
import { _fetchTransaction } from "./Proposal";
import get from 'lodash/get';


export function setNetworkId(networkId) {
  return async function (dispatch, getState) {
    dispatch({
      type: SET_NETWORKID,
      networkId: networkId
    }
    );
  };
}

export function setProvider(provider) {
  return async function (dispatch, getState) {
    dispatch({
      type: SET_PROVIDER,
      provider: provider
    })
  }
}

export function setAddress(address) {
  return async function (dispatch, getState) {
    dispatch({
      type: SET_ADDRESS,
      address: address,
    })
  }
}

export function setIsConnecting(isConnecting) {
  return async function (dispatch, getState) {
    dispatch({
      type: SET_ISCONNECTING,
      isConnecting: isConnecting,
    })
  }
}

export function setHasError(hasError) {
  return async function (dispatch, getState) {
    dispatch({
      type: SET_HASERROR,
      hasError: hasError
    })
  }
}
export async function fetchBalanceAsync(address) {
  const contractAddress = TDropStakingAddress[config.defaultThetaChainID];
  const contract = new web3.eth.Contract(TDropStakingAbi, contractAddress);
  const blockNum = await web3.eth.getBlockNumber();
  return smartContractFetchRPC(FETCH_BALANCE, {
    fn: contract.methods.getPriorVotes,
    inputValues: [address, blockNum],
    callData: {}
  })
}
export function fetchBalance(address) {
  return function (dispatch, getState) {
    fetchBalanceAsync(address).then(function (thunk) {
      if (thunk) {
        dispatch(thunk);
      }
    });
  };
}

export async function delegateAsync(dispatch, address, provider) {

  // return smartContractFetchRPC(DELEGATE, {
  //   fn: contract.methods.delegate,
  //   inputValues: [address],
  //   callData: {}
  // })
  dispatch({
    type: DELEGATE_START
  });
  try {
    const contractAddress = TDropStakingAddress[config.defaultThetaChainID];
    const contract = new web3.eth.Contract(TDropStakingAbi, contractAddress);
    const count = await web3.eth.getTransactionCount(address);
    let gas = web3.utils.toHex(100000);
    try {
      gas = await provider.request({
        method: 'eth_estimateGas',
        params: [{
          "from": address,
          "nonce": web3.utils.toHex(count),
          "to": TDropStakingAddress[config.defaultThetaChainID],
          "data": contract.methods.delegate(address).encodeABI()
        }],
      });
    } catch (e) {
      console.log('estimateGas in vote failed, error:', e.message);
    }

    const txHash = await provider.request({
      method: 'eth_sendTransaction',
      params: [{
        "from": address,
        "nonce": web3.utils.toHex(count),
        "gas": gas,
        "to": TDropStakingAddress[config.defaultThetaChainID],
        "data": contract.methods.delegate(address).encodeABI()
      }],
    });

    const txRes = await _fetchTransaction(txHash, 1);

    const tx = await txRes.json();

    const err = get(tx, 'body.receipt.EvmErr');
    if (err) {
      let evmRetText = Buffer.from(get(tx, 'body.receipt.EvmRet'), 'base64').toString();
      evmRetText = evmRetText.replace('\u0000', "").split('GovernorAlpha::');
      const evmRet = evmRetText[1];
      const errMsg = err + '. Detail: ' + evmRet;
      dispatch({
        type: DELEGATE_FAILURE,
        errMsg
      });
      return;
    }

    dispatch({
      type: DELEGATE_SUCCESS
    })
    dispatch(fetchDelegates(address));
    dispatch(fetchBalance(address));
  } catch (e) {
    dispatch({
      type: DELEGATE_FAILURE,
      errMsg: e.message
    })
  } finally {
    dispatch({
      type: DELEGATE_END
    })
  }
}

export function delegate(address, provider) {
  return function (dispatch, getState) {
    delegateAsync(dispatch, address, provider).then(function (thunk) {
      if (thunk) {
        dispatch(thunk);
      }
    });
  };
}

export async function fetchDelegatesAsync(address) {
  const contractAddress = TDropStakingAddress[config.defaultThetaChainID];
  const contract = new web3.eth.Contract(TDropStakingAbi, contractAddress);
  return smartContractFetchRPC(FETCH_DELEGATES, {
    fn: contract.methods.delegates,
    inputValues: [address],
    callData: {}
  })
}
export function fetchDelegates(address) {
  return function (dispatch, getState) {
    fetchDelegatesAsync(address).then(function (thunk) {
      if (thunk) {
        dispatch(thunk);
      }
    });
  };
}